import React from "react";

import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

import checksuccess from "views/job-details/img/checksuccess.png";
import offerletter from "views/profile/img/offerletter.png";
class JobOfferPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isSuccess: false };
    // console.log(props.showRefer);
  }
  render() {
    return (
      <>
        <Modal
          center
          open={this.props.showOffer}
          onClose={this.props.onclose}
          classNames={{
            modal: "modal-w900px",
          }}
        >
          <div className="refer-modal lg:p-4 md:p-4 ">
            {!this.state.isSuccess && (
              <div>
                <div>
                  <h2 className="refer-h2 uppercase fsize22 sm-fsize16">
                    JOB OFFER
                  </h2>
                </div>
                <div className="text-center">
                  <div>
                    <div className="lg:px-4 md:px-4">
                      <div className="lg:flex md:flex justify-center items-center m-auto ">
                        <div className="lg:w-2/5 md:w-2/5 w-full">
                          <div className="joboffer-img-w290">
                            <p className="fsize16 text-black text-left  mb-4">
                              You have{" "}
                              <span className="text189008">Accepted</span> the
                              Job Offer!
                            </p>
                            <img
                              src={offerletter}
                              alt="offerletter"
                              className="rounded-lg joboffer-img-h210"
                            />
                            <p className="underline text-white fsize20 font-bold  cursor-pointer ">
                              View Offer Letter
                            </p>
                          </div>
                        </div>
                        <div className="lg:w-3/5 md:w-3/5 w-full lg:px-8 md:px-8">
                          <div class="form-group  modal-form-cs text-left">
                            <label for="">Select Joining Date</label>
                            <input type="date" placeholder="" />
                          </div>
                          <div className="flex items-center mt-12">
                            {/* <input type="checkbox" className="w-18px h-18px " /> */}
                            <label class="custcheckbox">
                              <p className="text262626 fsize14 opacity-80per ml-2">
                                I agree to the terms and conditions and
                                accepting the offer shared with me
                              </p>
                              <input type="checkbox" checked />
                              <span class="overhide-span"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="mt-12 sm-w-full text-right">
                        <button className="filled-button uppercase rounded-25px  sm-fsize14 sm-w-full fsize16 font-bold btn-disclaimer lg:ml-3 md:ml-3">
                          SUBMIT
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.isSuccess && (
              <div>
                <img src={checksuccess} className="m-auto" />
                <h1 className="fsize18 text-center font-bold line-h25 mt-4">
                  Referral Success
                </h1>
                <div class="w-full fixed-btn lg:mt-16 md:mt-16 mt-6">
                  <a
                    class="btn btn-orange-otp btn-otp-wauto mx-auto myBtn"
                    href="#"
                  >
                    REFER ANOTHER FRIEND
                  </a>
                </div>
              </div>
            )}
          </div>
        </Modal>
      </>
    );
  }
}

export default JobOfferPopup;
